import { render, staticRenderFns } from "./grant-respond.vue?vue&type=template&id=4d53af84"
import script from "./grant-respond.vue?vue&type=script&lang=js"
export * from "./grant-respond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports